__turbopack_context__.v({
  "body": "CourseCTACard-module__QgWOyq__body",
  "card": "CourseCTACard-module__QgWOyq__card",
  "content": "CourseCTACard-module__QgWOyq__content",
  "contentTop": "CourseCTACard-module__QgWOyq__contentTop",
  "description": "CourseCTACard-module__QgWOyq__description",
  "imageWrapper": "CourseCTACard-module__QgWOyq__imageWrapper",
  "infoItem": "CourseCTACard-module__QgWOyq__infoItem",
  "infoLabel": "CourseCTACard-module__QgWOyq__infoLabel",
  "infoValue": "CourseCTACard-module__QgWOyq__infoValue",
  "selectionInfo": "CourseCTACard-module__QgWOyq__selectionInfo",
  "title": "CourseCTACard-module__QgWOyq__title",
});
